import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE_DRIVER_JOB_ONBOARDING_PROFILE } from '../../shared/routes';
import { OnboardingService } from '../../shared/onboarding.service';
import { PublicCarrier } from 'src/app/shared/models/public-carrier';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-onboarding-account',
    templateUrl: './onboarding-account.component.html',
    styleUrls: ['./onboarding-account.component.scss'],
    standalone: false
})
export class OnboardingAccountComponent implements OnInit, OnDestroy {
  carrierData: PublicCarrier | null = null;
  isLoading = false;
  private subscription = new Subscription();
  
  constructor(
    private router: Router,
    private onboardingService: OnboardingService
  ) {}

  ngOnInit(): void {
    // Subscribe to carrier data changes
    this.subscription.add(
      this.onboardingService.carrierData$.subscribe(data => {
        this.carrierData = data;
      })
    );

    // Subscribe to loading state
    this.subscription.add(
      this.onboardingService.isLoading$.subscribe(loading => {
        this.isLoading = loading;
      })
    );

    // Load carrier data (will use cached data if already loaded)
    this.onboardingService.loadCarrierData();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onNext(): void {
    this.router.navigate([ROUTE_DRIVER_JOB_ONBOARDING_PROFILE]);
  }
}
